import styled, { css } from 'styled-components';

const PhonePreview = styled.div(
  ({ theme: { images } }) => css`
    background: url(${images.iphoneImage}) no-repeat center center;
    background-size: 500px 550px;
    display: flex;
    flex-direction: column;
    height: 550px;
    overflow: hidden;
    padding-bottom: 20px;
    padding-left: 32px;
    padding-right: 30px;
    position: relative;
    width: 300px;
  `
);

const DigitalWrapper = styled.div`
  background-image: url(${({ src }) => src});
  background-size: 500px 550px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  height: 488px;
  justify-content: center;
  margin: 42px auto 0;
  position: absolute;
  width: 238px;
`;

const ExperienceBow = styled.div(
  ({ theme: { images } }) => css`
    background: url(${images.experienceBow}) no-repeat center center;
    background-size: 350px 350px;
    border-radius: 24px;
    display: flex;
    flex: unset;
    flex-direction: column;
    height: 300px;
    margin-top: 120px;
    overflow: hidden;
    position: absolute;
    position: relative;
    width: 240px;
  `
);

export { DigitalWrapper, ExperienceBow, PhonePreview };
